(function () {
  const overlay = document.querySelector('[data-search-overlay]');
  const backdrop = document.querySelector('[data-search-backdrop]');

  if (!overlay) return;

  const theme = window.WSTheme || {};
  const strings = theme.strings || {};
  const routes = theme.routes || {};
  const form = overlay.querySelector('.search-overlay__form');
  const input = overlay.querySelector('[data-search-input]');
  const clearButton = overlay.querySelector('[data-search-clear]');
  const helper = overlay.querySelector('[data-search-helper]');
  const results = overlay.querySelector('[data-search-results]');
  const body = document.body;
  const showJournal = theme.showJournal === true;
  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang === 'de' ? 'de-DE' : 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  });

  let debounceTimer;
  let activeRequest;
  let lastFocusedElement;
  let generation = 0;
  let restoringFocus = false;
  const homeForm = document.querySelector('.b-header-search');
  const homeInput = homeForm?.querySelector('input');
  function cancelSearch() {
    window.clearTimeout(debounceTimer);
    activeRequest?.abort();
    activeRequest = null;
    generation++;
  }

  const escapeHtml = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const formatSearchMoney = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? moneyFormatter.format(amount) : '';
  };

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(event) {
    const focusable = Array.from(overlay.querySelectorAll(focusableSelector)).filter((node) => !node.hidden && node.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function setOpenState(isOpen) {
    overlay.hidden = !isOpen;
    backdrop?.toggleAttribute('hidden', !isOpen);
    body.classList.toggle('body-scroll-locked', isOpen);
  }

  function syncClearButton() {
    clearButton?.toggleAttribute('hidden', !input?.value);
  }

  function resetOverlay() {
    if (helper) helper.textContent = strings.searchHelper;
    if (results) results.innerHTML = '';
    syncClearButton();
  }

  function openOverlay(trigger) {
    cancelSearch();
    if (trigger === homeInput && input) input.value = homeInput.value;
    lastFocusedElement = trigger || document.activeElement;
    setOpenState(true);
    resetOverlay();
    input?.focus({preventScroll: true});
    if (input?.value.trim()) runSearch(input.value.trim());
  }

  function closeOverlay() {
    cancelSearch();
    if (homeInput && lastFocusedElement === homeInput) homeInput.value = input.value;
    setOpenState(false);
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      restoringFocus = true;
      lastFocusedElement.focus({preventScroll: true});
      restoringFocus = false;
    }
  }

  function buildSection(title, items) {
    if (!items.length) return '';

    return `
      <section class="search-overlay__section">
        <h3>${escapeHtml(title)}</h3>
        <ul>${items.join('')}</ul>
      </section>
    `;
  }

  function productResultMarkup(product) {
    const image = product.featured_image?.url || product.image || product.image_url || '';
    const price = formatSearchMoney(product.price);
    const compareAtPrice = formatSearchMoney(product.compare_at_price);
    const hasSalePrice = Number(product.compare_at_price) > Number(product.price);
    const priceMarkup = hasSalePrice
      ? `<small class="search-overlay__result-price"><s>${escapeHtml(compareAtPrice)}</s><span>${escapeHtml(price)}</span></small>`
      : price
        ? `<small>${escapeHtml(price)}</small>`
        : '';

    return `
      <li>
        <a href="${escapeHtml(product.url)}" class="search-overlay__result search-overlay__result--product">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
              : `<span class="search-overlay__thumb search-overlay__thumb--placeholder" aria-hidden="true"></span>`
          }
          <span class="search-overlay__result-copy">
            <span>${escapeHtml(product.title)}</span>
            ${priceMarkup}
          </span>
        </a>
      </li>
    `;
  }

  function linkResultMarkup(item) {
    return `<li><a href="${escapeHtml(item.url)}" class="search-overlay__result"><span class="search-overlay__result-copy"><span>${escapeHtml(item.title)}</span></span></a></li>`;
  }

  function collectionResultMarkup(collection) {
    const image = collection.featured_image?.url || collection.image || collection.image_url || '';
    if (!image) return linkResultMarkup(collection);
    return `<li><a href="${escapeHtml(collection.url)}" class="search-overlay__world-card"><img src="${escapeHtml(image)}" alt="${escapeHtml(collection.title)}" loading="lazy"><span>${escapeHtml(collection.title)}</span></a></li>`;
  }

  function renderIdleState() {
    if (helper) helper.textContent = strings.searchHelper;
    if (results) results.innerHTML = '';
  }

  function renderLoadingState() {
    if (helper) helper.textContent = strings.searchLoading;
    if (results) {
      results.innerHTML = '<div class="search-overlay__state"><p>…</p></div>';
    }
  }

  function renderErrorState() {
    if (helper) helper.textContent = strings.searchError;
    if (results) {
      results.innerHTML = `<div class="search-overlay__state"><p>${escapeHtml(
        strings.searchError
      )}</p></div>`;
    }
  }

  function renderResultsState(query, payload) {
    const products = (payload.products || []).slice(0, 4);
    const collections = (payload.collections || []).slice(0, 2);
    const articles = showJournal ? (payload.articles || []).slice(0, 2) : [];
    const hasResults = products.length || collections.length || articles.length;
    const viewAllUrl = `${routes.search || '/search'}?q=${encodeURIComponent(query)}`;

    if (helper) helper.textContent = hasResults ? '' : strings.searchEmpty;

    if (!results) return;

    if (!hasResults) {
      results.innerHTML = `
        <div class="search-overlay__state search-overlay__state--empty">
          <svg class="utility-icon utility-icon--search" viewBox="0 0 64 64" aria-hidden="true"><circle cx="28" cy="28" r="13" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m38 38 11 11" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <h3>${escapeHtml(strings.searchEmpty)}</h3>
          <p>${escapeHtml(strings.searchEmptySubtext)}</p>
          <a href="${escapeHtml(viewAllUrl)}" class="search-overlay__view-all">${escapeHtml(strings.searchViewAll)}</a>
        </div>
      `;
      return;
    }

    results.innerHTML = `
      ${buildSection(strings.searchProducts, products.map(productResultMarkup))}
      ${collections.length ? `<section class="search-overlay__section search-overlay__section--worlds"><h3>${escapeHtml(strings.searchWorlds)}</h3><ul>${collections.map(collectionResultMarkup).join('')}</ul></section>` : ''}
      ${buildSection(strings.searchJournal, articles.map(linkResultMarkup))}
      <a href="${escapeHtml(viewAllUrl)}" class="search-overlay__view-all">${escapeHtml(
        strings.searchViewAll
      )}</a>
    `;
  }

  async function runSearch(query) {
    if (!query || overlay.hidden || input.value.trim() !== query) return;
    cancelSearch();
    const requestGeneration = generation;
    const controller = new AbortController();
    activeRequest = controller;
    const isCurrent = () => generation === requestGeneration && !controller.signal.aborted && !overlay.hidden && input.value.trim() === query;
    renderLoadingState();

    try {
      const url = new URL('/search/suggest.json', window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', showJournal ? 'product,collection,article' : 'product,collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');

      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });

      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

      const data = await response.json();
      const payload = data.resources?.results || {};
      if (isCurrent()) renderResultsState(query, payload);
    } catch (error) {
      if (error.name === 'AbortError' || !isCurrent()) return;
      renderErrorState();
    }
  }

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-search-open]');
    if (openTrigger) {
      event.preventDefault();
      openOverlay(openTrigger);
      return;
    }

    if (event.target.closest('[data-search-close]') || event.target === backdrop) {
      event.preventDefault();
      closeOverlay();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (overlay.hidden) return;
    if (event.key === 'Tab') {
      trapFocus(event);
      return;
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      closeOverlay();
    }
  });

  clearButton?.addEventListener('click', () => { cancelSearch(); input.value = ''; syncClearButton(); renderIdleState(); input.focus(); });

  input?.addEventListener('input', () => {
    cancelSearch();
    syncClearButton();
    const query = input.value.trim();

    if (!query) {
      renderIdleState();
      return;
    }

    debounceTimer = window.setTimeout(() => runSearch(query), 220);
  });

  form?.addEventListener('submit', () => {
    closeOverlay();
  });

  homeInput?.addEventListener('focus', () => {
    if (!restoringFocus && overlay.hidden) openOverlay(homeInput);
  });
  homeInput?.addEventListener('click', () => {
    if (overlay.hidden) openOverlay(homeInput);
  });
  homeForm?.addEventListener('submit', event => {
    event.preventDefault();
    openOverlay(homeInput);
  });
  resetOverlay();
})();
